export const experienceData = [
    {   iconUrl: "/exp-images/comsoc.jpeg",
        position:"Committee Member",
        organization: "IEEE ComSoc Student Branch Chapter of UoJ",
        time: "Oct 2024 - Present",
        section: "Science & Technology",
        details: ""
        
    },

    {
        iconUrl: "/exp-images/saanaka.jpeg",
        position:"Committee Member",
        organization: "Sasnaka Sansada Foundation",
        time: "Dec 2021 - Present",
        section: "Education",
        details: "Developed notes and contents for the official online learning web site of Sasnaka Sansada Foundation"
        
    },
    
    {
        iconUrl: "/exp-images/ieee.jpg",
        position:"Committee Member",
        organization: "IEEE",
        time: "Apr 2024 - Present",
        section: "Science & Technology",
        details: "Participated events held by IEE Student branch of UoJ"
        
    },
    {
        iconUrl: "/exp-images/iesl.webp",
        position:"Committee Member",
        organization: "IESL Student Chapter - University of Jaffna",
        time: "Jan 2023 - Present",
        section: "Science & Technology",
        
    }
    
    
]